import React from 'react';
import PropTypes from 'prop-types';
import { stylingText } from 'actions/livefeed'

const TextOption = (props) => {
    const { currentEntity, dispatch } = props;

    const activeToolbarItems = currentEntity && currentEntity.activeToolbarItems;
    const isText = currentEntity && (currentEntity.id !== null && activeToolbarItems[2].isText);

    function handleFormatText(type) {
        let style = {};
        switch (type) {
            case "bold":
                // toggle style
                style.bold = !currentEntity.textStyle.bold
                break;
            case "italic":
                style.italic = !currentEntity.textStyle.italic
                break;
            case "underline":
                style.underline = !currentEntity.textStyle.underline
                break;
        }
        dispatch(stylingText(style))
    }

    function multileActiveItem(item) {
        if (currentEntity.id !== null) {
            if (activeToolbarItems[2].bold && item === "bold") {
                return 'icon-wrapper_active'
            } else if (activeToolbarItems[2].italic && item === "italic") {
                return 'icon-wrapper_active'
            } else if (activeToolbarItems[2].underline && item === "underline") {
                return 'icon-wrapper_active'
            } else
                return ''
        }
    }

    function activeTextClass(item) {
        let classes = `icon-wrapper justify-center ${multileActiveItem(item)} ${isText ? '' : 'icon-wrapper_disable'}`
        return classes
    }

    return (
        <React.Fragment>
            <div className={activeTextClass("bold")} onClick={() => isText ? handleFormatText("bold") : null}>
                <i data-tooltip="Bold Text" style={{ fontSize: "24px" }} className="material-icons">format_bold</i>
            </div>
            <div className={activeTextClass("italic")} onClick={() => isText ? handleFormatText("italic") : null}>
                <i data-tooltip="Italic Text" style={{ fontSize: "24px" }} className="material-icons">format_italic</i>
            </div>
            <div className={activeTextClass("underline")} onClick={() => isText ? handleFormatText("underline") : null}>
                <i data-tooltip="Underline Text" style={{ fontSize: "24px" }} className="material-icons">format_underlined</i>
            </div>
        </React.Fragment>
    );
}

TextOption.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentEntity: PropTypes.object.isRequired
}
export default TextOption;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/TextOption.jsx